<img [src]="src"
     (error)="replaceSrc()"
     [alt]="title"
     [title]='title'>
